const users = {
    assigner: {
        header: '[EN] Przypisywanie użytkownikó',
        buttons: {
            cancel: {
                label: '[EN] Anuluj'
            },
            confirm: {
                label: '[EN] Przypisz',
            },
        },
        toAssign: {
            header:{
                title: '[EN] Użytkownicy do wybrania',
                text: '[EN] Kliknij aby przenieść użytkownika na drugą liste',
            },
            searchPlaceholder: '[EN] Wyszukaj...',
            tooltip: '[EN] Kliknij aby przenieść użytkownika na drugą liste',
        },
        assigned: {
            header: {
                title: '[EN] Użytkownicy do przypisania',
                text: '[EN] Kliknij aby przenieść użytkownika na pierwszą liste',
            },
            searchPlaceholder: '[EN] Wyszukaj...',
            tooltip: '[EN] Kliknij aby przenieść użytkownika na pierwszą liste',
        },
    }
};

export default users;